import {
  pure,
  renderComponent,
  branch,
  compose
} from 'recompose'
import Input from './Input'
import FieldWrapper from './FieldWrapper'

export default compose(
  branch(props => props.formComponent, renderComponent(FieldWrapper)),
  pure
)(Input)



// WEBPACK FOOTER //
// ./components/uiLib/Input/index.js